import store from '@/store/store.js';  // Import your store
import router from '@/router.js'  // Import your router instance

// src/utils/sessionTimer.js
let warningTimer = null;
let logoutTimer  = null;
let sessionExpiresAt = null;

export function startSessionTimers(warningTimeSeconds, logoutTimeSeconds) {
    clearSessionTimers();  // safety first

    sessionExpiresAt = Date.now() + logoutTimeSeconds * 1000;
    store.commit('setSessionExpiry', sessionExpiresAt);

    warningTimer = setTimeout(() => {
      store.dispatch('toastNotifications/notify', {
        severity: 'warn',
        summary: 'Sitzung läuft ab',
        detail: 'Sie werden in 10 Minuten automatisch ausgeloggt.',
        life: 10 * 60 * 1000,
        action: { label: 'Sitzung verlängern', name: 'refreshUserToken' }
      });
    }, warningTimeSeconds * 1000);

    logoutTimer = setTimeout(() => {
      store.dispatch('logoutUser');
      router.push({ name: 'login' });
    }, logoutTimeSeconds * 1000);
}

export function getSessionExpiresAt() {
    return sessionExpiresAt;
}

export function clearSessionTimers() {
  if (warningTimer) { clearTimeout(warningTimer); warningTimer = null; }
  if (logoutTimer)  { clearTimeout(logoutTimer);  logoutTimer  = null; }
  sessionExpiresAt = null;
}
